import {
  DynamicField,
  FieldVariant,
  SelectFieldProps,
  TextFieldProps,
  DynamicForm,
  SelectOption,
  DateFieldProps,
} from '@/components/form-builder/form-builder.types';
import { CompanyRepository } from '@/store/company-state/company-state.repository';
import { map, of } from 'rxjs';

interface IGetInspectCompanyFormObjectProps {
  store: CompanyRepository;
  companiesTypesOptions?: SelectOption[];
  companyCategoriesOptions?: SelectOption[];
  companyCountriesOptions?: SelectOption[];
}

export const getInspectCompanyFormObject = ({
  store,
  companiesTypesOptions,
  companyCategoriesOptions,
  companyCountriesOptions,
}: IGetInspectCompanyFormObjectProps): DynamicForm => {
  const nameField: DynamicField<TextFieldProps> = {
    label: 'settings.companyInfo.form.name.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<string>('dto', 'nom'),
    },
  };
  const typeField: DynamicField<SelectFieldProps> = {
    label: 'settings.companyInfo.form.type.label',
    variant: FieldVariant.SELECT,
    isDisabled: of(true),
    props: {
      placeholder: 'settings.companyInfo.form.type.placeholder',
      options: companiesTypesOptions,
      value: store.getObservable('companyTypeSelected'),
    },
  };

  const nifField: DynamicField<TextFieldProps> = {
    label: 'settings.companyInfo.form.nif.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<string>('dto', 'nif'),
    },
  };

  const nifDateField: DynamicField<DateFieldProps> = {
    label: 'settings.companyInfo.form.nifDate.label',
    variant: FieldVariant.DATE,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<string>('dto', 'dateNif').pipe(map(date => new Date(date))),
    },
  };

  const numCnssField: DynamicField<TextFieldProps> = {
    label: 'settings.companyInfo.form.numCnss.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<string>('dto', 'numCnss'),
    },
  };

  const submissionCategoryField: DynamicField<SelectFieldProps> = {
    label: 'settings.companyInfo.form.categorySoumissionnaire.label',
    variant: FieldVariant.SELECT,
    isDisabled: of(true),
    props: {
      placeholder: 'settings.companyInfo.form.categorySoumissionnaire.placeholder',
      options: companyCategoriesOptions,
      value: store.getObservable('companyCategorySelected'),
    },
  };

  // addresse fields

  const addressField: DynamicField<TextFieldProps> = {
    label: 'settings.companyInfo.form.adresse.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<string>('dto', 'address', 'adresse'),
    },
  };
  const extraAddressField: DynamicField<TextFieldProps> = {
    label: 'settings.companyInfo.form.extraAddress.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<string>('dto', 'address', 'compAdresse'),
    },
  };
  const postalCodeField: DynamicField<TextFieldProps> = {
    label: 'settings.companyInfo.form.postalCode.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<string>('dto', 'address', 'codePostal'),
    },
  };
  // const cityField: DynamicField<TextFieldProps> = {
  //   label: 'settings.companyInfo.form.city.label',
  //   variant: FieldVariant.TEXT,
  //   isDisabled: of(true),
  //   props: {
  //     value: store.getNestedObservable<string>('dto', 'address', 'ville'),
  //   },
  // };

  const tel1Field: DynamicField<TextFieldProps> = {
    label: 'settings.companyInfo.form.tel1.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<string>('dto', 'address', 'tel1'),
    },
  };
  const tel2Field: DynamicField<TextFieldProps> = {
    label: 'settings.companyInfo.form.tel2.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<string>('dto', 'address', 'tel2'),
    },
  };
  const faxField: DynamicField<TextFieldProps> = {
    label: 'settings.companyInfo.form.fax.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<string>('dto', 'address', 'fax'),
    },
  };

  const emailField: DynamicField<TextFieldProps> = {
    label: 'settings.companyInfo.form.email.label',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<string>('dto', 'address', 'email'),
    },
  };
  const countryField: DynamicField<SelectFieldProps> = {
    label: 'settings.companyInfo.form.country.label',
    variant: FieldVariant.SELECT,
    isDisabled: of(true),
    props: {
      placeholder: 'settings.companyInfo.form.country.placeholder',
      options: companyCountriesOptions,
      value: store.getNestedObservable<SelectOption>('companyCountrySelected'),
    },
  };

  return {
    title: 'Company',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [nameField, numCnssField],
          },
          {
            fields: [typeField, submissionCategoryField],
          },
          {
            fields: [nifField, nifDateField],
          },
        ],
      },
      {
        title: 'Address',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [addressField, extraAddressField],
          },
          {
            fields: [postalCodeField, countryField], //cityField
          },
          {
            fields: [tel1Field, tel2Field, faxField, emailField],
          },
        ],
      },
    ],
  };
};
